export default class ImagesPublicService {
    async index(label=false) {
        let response = await fetch(`/api/public/images/${label!==false ? label : ''}`);
        return await response.json();
    }
}